import moment from 'moment';

const transformAll = ({ data }) => {
  data = (data.employers || [])
    .filter(employer => !employer.deletedAt)
    .map(({ emails, ...rest }) => ({
      ...rest,
      emails: emails == -1 ? [] : emails
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return data;
};

const transformBeforeSave = ({ branches, sponsors, ...data }) => {};

export { transformAll, transformBeforeSave };
